
import {defineComponent} from "vue";
import {mapActions, mapGetters, mapState} from "vuex";
import FilterSection from "./FilterSection.vue";
import SpinnerGlobal from "@/components/common/SpinnerGlobal.vue";
import ButtonCloseFilter from "@/components/controls/ButtonCloseFilter.vue";
import {store} from "@/store";
import {FilterActionTypes} from "@/store/modules/filter/action-types";

export default defineComponent({
    name: "FilterHolder",
    components: {
        ButtonCloseFilter,
        SpinnerGlobal,
        FilterSection
    },
    setup() {
        function closeFilterModal(): void {
            store.dispatch(FilterActionTypes.SET_IS_OPENED_FILTER_MODAL, false);
        }

        return {
            horizontal: true,
            closeFilterModal,
        }
    },
    props: {
        isLoading: {
            type: Boolean,
            required: true,
        }
    },
    computed: {
        ...mapState(['filter']),
        ...mapGetters({
            filterTitle: 'getFilterTitle',
            cancelLabel: 'getCancelFilterLabel',
            changedSlides: 'getChangedSlides',
            selectedChecks: 'getFilterSelection',
            isOpenedFilterModal: 'getIsOpenedFilterModal',
            closeFilterLabel: 'getCloseFilterLabel',
            applyFilterLabel: 'getApplyFilterLabel',
        }),
        applyOrCloseFilterLabel() {
            return this.isAppliedFilter ? this.applyFilterLabel : this.closeFilterLabel;
        },
        isAppliedFilter() {
            return this.changedSlides.length || this.selectedChecks.length;
        }
    },
    methods: mapActions({
        clearFilter: 'CLEAR_FILTRATION'
    })
});
